/**
 * Mixin for room stock availability functionality
 * Provides methods to retrieve room inventory and stock left information
 * Used in components that display room availability for Koedia accommodations
 */

export default {
  methods: {
    /**
     * Get inventory data for a specific room
     * @param {number} roomId - The room ID
     * @returns {object|null} - Inventory object or null if not found
     */
    getInventoryForRoom(roomId) {
      if (!this.roomInventories) {
        return null;
      }

      // Find the room by ID to compare Koedia room id first, then name fallback
      const room = this.rooms.find(r => r.id === roomId);
      if (!room) {
        return null;
      }

      const normalizedRoomId = room.koedia_room_id ? String(room.koedia_room_id).toLowerCase().trim() : '';
      const normalizedRoomName = (room.koedia_room_name || room.name || '').toLowerCase().trim();

      if (normalizedRoomId) {
        for (const key in this.roomInventories) {
          if (String(key).toLowerCase().trim() === normalizedRoomId) {
            return this.roomInventories[key];
          }
        }
      }

      // Search through inventories to find a match by the 'name' property
      for (const key in this.roomInventories) {
        const inventory = this.roomInventories[key];
        if (inventory && inventory.name) {
          const normalizedInventoryName = inventory.name.toLowerCase().trim();
          // Exact match with case-insensitive comparison
          if (normalizedInventoryName === normalizedRoomName) {
            return inventory;
          }
        }
      }

      return null;
    },

    /**
     * Get the stock left for a specific room
     * Only returns stock for Koedia accommodations
     * @param {object} room - The room object
     * @returns {number|null} - Number of rooms left in stock or null
     */
    getRoomStockLeft(room) {
      // For Koedia accommodations, get from inventory
      if (this.accommodation_code) {
        const inventory = this.getInventoryForRoom(room.id);
        if (inventory && inventory.hasOwnProperty('stock_left')) {
          return inventory.stock_left;
        }
      }
      return null;
    }
  }
};
